import React from 'react'

function Links({ location }) {
    let link;
    if (location === 'home') {
        link = '/'
    } else {
        link = `/${location}`
    }
    return (
        <li className="nav-item " id={`${location}`}>
            <a className="nav-link" href={link}>{location.charAt(0).toUpperCase() + location.slice(1)}</a>
        </li>
    )
}

export default Links
